<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>员工管理</el-breadcrumb-item>
      <el-breadcrumb-item>员工列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-button size="mini" @click="checkEmployee" >审核</el-button>
      <el-button size="mini" @click="leavingEmployee" >离职</el-button>
      <el-button size="mini" @click="entryEmployee" >复职</el-button>
      <el-button size="mini" @click="showAllotRole" >分配角色</el-button>
      <el-button size="mini" @click="showModifyOrg">调整人员机构</el-button>
      <el-button size="mini" @click="deleteUserOrg">删除人员机构</el-button>
      <el-input size="mini" placeholder="请输入姓名或手机号进行搜索"
                v-model="queryText"
                style="width: 200px;padding-bottom: 5px"></el-input>
    <el-button size="mini" @click="queryEmployee">查询</el-button>
      <el-tabs v-model="activeName" type="border-card"  @tab-click="handleClick"
               style="height: 650px;">
        <el-tab-pane name="1" label="注册员工">
          <el-table height="550px" :data="registerEmployeeList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              label="操作"
              align="center"
              width="100">
              <template slot-scope="scope">
                <el-radio :label="scope.row.id" v-model="employee"  @change.native="selectEmployee(scope.row)">{{''}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              label="姓名"
              align="center">
            </el-table-column>
            <el-table-column
              prop="loginId"
              label="登录账号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="roleName"
              label="职位"
              align="center">
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="所在机构"
              align="center">
            </el-table-column>
            <el-table-column
              prop="comment"
              label="注册说明"
              align="center">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="注册时间"
              align="center">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal1">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2" label="正常员工">
          <el-table height="550px" :data="employeeList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              label="操作"
              align="center"
              width="100">
              <template slot-scope="scope">
                <el-radio :label="scope.row.userOrgId" v-model="employee"  @change.native="selectEmployee(scope.row)">{{''}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              label="姓名"
              align="center">
            </el-table-column>
            <el-table-column
              prop="loginId"
              label="登录账号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="roleName"
              label="职位"
              align="center">
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="所在机构"
              align="center">
            </el-table-column>
            <el-table-column
              prop="comment"
              label="注册说明"
              align="center">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="注册时间"
              align="center">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="3" label="离职员工">
          <el-table height="550px" :data="leaveEmployeeList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="{height: '0'}">
            <el-table-column
              label="操作"
              align="center"
              width="100">
              <template slot-scope="scope">
                <el-radio :label="scope.row.id" v-model="employee"  @change.native="selectEmployee(scope.row)">{{''}}</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              label="姓名"
              align="center">
            </el-table-column>
            <el-table-column
              prop="loginId"
              label="登录账号"
              align="center">
            </el-table-column>
            <el-table-column
              prop="roleName"
              label="职位"
              align="center">
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="所在机构"
              align="center">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="注册时间"
              align="center">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="currentPage2"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal2">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>

    <!-- 分配角色 -->
    <el-dialog
      title="分配角色"
      :visible.sync="allotRoleDialogVisible"
      width="50%"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: space-between;margin-top: 20px">
        <div>
          员工名称：
          <el-input v-model="selectedEmployee.userName" readonly size="mini" style="width: 250px"></el-input>
        </div>
      </div>

      <div style="display: flex;justify-content: space-between;margin-top: 20px">
        <div>
          角色类别：
          <el-radio-group v-model="selectedEmployee.roleId" @change="getRoleType">
            <el-radio
              v-for="role in roles"
              :key="role.id"
              :label="role.id"
              :value="role.id">
              {{role.roleName}}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeAllotRole">取 消</el-button>
            <el-button size="mini" @click="updateUserRole">确 定</el-button>
          </span>
    </el-dialog>


    <!-- 显示服务和产品-->
    <el-drawer
      title="调整机构"
      size="60%"
      :visible.sync="modifyOrgDrawer"
      :before-close="closeModifyOrgDrawer"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <el-input size="mini"
                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                      placeholder="输入关键字进行过滤"
                      v-model="areaFilterText">
            </el-input>
            <el-tree
              :data="areaList"
              :props="areaProps"
              @node-click="areaHandleNodeClick"
              :highlight-current="true"
              node-key="id"
              :filter-node-method="areaFilterNode"
              default-expand-all
              ref="serviceTree"
            >
            </el-tree>
          </div>
        </div>
        <div class="table_container" style="margin: 10px 0">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="shopQueryText"
                    @keyup.enter.native="queryShopMethod"
          >
          </el-input>
          <el-table height="550px" :data="shopList" fit border stripe="stripe"
                    :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    :row-style="isBlue"
                    ref="multipleTable"
                    >
            <el-table-column
              align="center"
              fixed="fixed"
              label="操作" width="100"
              >
              <template slot-scope="scope">
                <el-link size="mini"
                         icon="iconfont icon-xuanze" type="primary" @click="addUserOrg(scope.$index, scope.row)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="orgName"
              label="门店名称">
            </el-table-column>
          </el-table>
          <div style="margin-top: 3px;">
            <el-pagination
              @size-change="handleSizeChange3"
              @current-change="handleCurrentChange3"
              :current-page="currentPage3"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="pageSize3"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal3">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgLevel:'',
      authorities:'',
      currentOrgId:'',
      employeeList: [],
      registerEmployeeList:[],
      leaveEmployeeList:[],
      queryText:'',
      validaText:[
        {valida:1,name:'注册'},
        {valida:2,name:'正常'},
        {valida:3,name:'离职'}
      ],
      employee:{
        id:'',
        userName:'',
        loginId:'',
        orgId:'',
        valida:'',
        roleId:1

      },
      selectedEmployee:{
        id:'',
        userName:'',
        loginId:'',
        orgId:'',
        valida:'',
        roleId:1,
        orgList:[]
      },
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,

      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,

      currentPage3: 1,
      pageSize3:20,
      pageTotal3:0,

      allotRoleDialogVisible:false,
      roles:[],
      modifyOrgDrawer:false,
      areaList:[],
      shopList:[],

      areaProps:{
        label: 'orgName',
        children: 'children'
      },
      shopQueryText:'',
      areaFilterText:'',
      selectAreaId:'',
      multipleSelection:[],
      newMultipleSelection:[],
      orgIsSelect:false,
      userRequest:{
        orgId:'',
        shopName:'',
        pageNum:'',
        pageSize:'',
        orgLevel:'',
        userState:'',
        queryText:''
      },
      activeName:'1'
    }
  },
  methods:{
    queryEmployee(){
      if (this.queryText !== ''){
        this.userRequest.queryText = this.queryText;
      } else {
        this.userRequest.queryText = '';
      }
      if (this.activeName === '1'){
        this.loadRegisterEmployees();
      }

      if (this.activeName === '2'){
        this.loadEmployees();
      }

      if (this.activeName === '3'){
        this.loadLeaveEmployees();
      }
    },
    handleClick(tab, event){
      this.activeName = tab.name;
      this.queryEmployee();
    },
    showModifyOrg(){
      if (this.selectedEmployee.id === ''){
        return this.$message.warning("请选择要调整的员工！")
      }
      this.loadAreaOrgs();
      this.loadUserExistOrg();
      this.modifyOrgDrawer = true;
    },
    isBlue({row}){
      const checkIds = this.multipleSelection.map((item) => item.id);
      if(checkIds.includes(row.id)){
        return {
          backgroundColor: "#68B4E9",
          color:"blue"
        }
      }
    },
    async loadUserExistOrg(){
      const {data:res} = await this.$http.get(`/users/exsitOrg/${this.selectedEmployee.id}`)
      if (res.code === 200){
        this.multipleSelection = res.data;
      }
    },
    closeModifyOrgDrawer(){
      this.updateUserOrg();
      this.modifyOrgDrawer = false;
    },
    async loadEmployees(){
      this.userRequest.pageNum = this.currentPage;
      this.userRequest.pageSize = this.pageSize;
      this.userRequest.orgId = this.currentOrgId;
      this.userRequest.orgLevel = this.orgLevel;
      this.userRequest.userState = 2;
      const {data:res} = await this.$http.post(`/users/manage`, this.userRequest);
      if (res.code === 200){
        this.employeeList = res.data.list;
        this.pageTotal = res.data.total;
      }
    },
    async loadRegisterEmployees(){
      this.userRequest.pageNum = this.currentPage1;
      this.userRequest.pageSize = this.pageSize1;
      this.userRequest.orgId = this.currentOrgId;
      this.userRequest.orgLevel = this.orgLevel;
      this.userRequest.userState = 1;
      const {data:res} = await this.$http.post(`/users/manage`, this.userRequest)
      if (res.code === 200){
        this.registerEmployeeList = res.data.list;
        this.pageTotal1 = res.data.total;
      }
    },
    async loadLeaveEmployees(){
      this.userRequest.pageNum = this.currentPage2;
      this.userRequest.pageSize = this.pageSize2;
      this.userRequest.orgId = this.currentOrgId;
      this.userRequest.orgLevel = this.orgLevel;
      this.userRequest.userState = 3;
      const {data:res} = await this.$http.post(`/users/manage`, this.userRequest);
      if (res.code === 200){
        this.leaveEmployeeList = res.data.list;
        this.pageTotal2 = res.data.total;
      }
    },
    validaFormatter(row){
      let value = "";
      for (let i = 0; i < this.validaText.length; i++){
        let item = this.validaText[i];
        if (row.valida === item.valida) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    selectEmployee(data){
      this.selectedEmployee = data;
    },
    async checkEmployee(){
      if (this.selectedEmployee.valida === 2){
        return this.$message.warning("此员工为正常员工，不需要审核！")
      }
      if (this.selectedEmployee.valida === 3){
        return this.$message.warning("此员工为离职员工，不需要审核！")
      }

      const {data:res} = await this.$http.put(`/user/modifier/${this.userId}/user/${this.selectedEmployee.id}/valida/${2}`)
      if (res.code === 200){
        await this.loadEmployees();
        await this.loadRegisterEmployees();
        await this.loadLeaveEmployees();
      }
    },
    async leavingEmployee(){
      if (this.selectedEmployee.valida === 1){
        return this.$message.warning("此员工为注册员工，不需要办理离职！")
      }
      if (this.selectedEmployee.valida === 3){
        return this.$message.warning("此员工为离职员工，不需要办理离职！")
      }

      const {data:res} = await this.$http.put(`/user/modifier/${this.userId}/user/${this.selectedEmployee.id}/valida/${3}`)
      if (res.code === 200){
        await this.loadEmployees();
        await this.loadRegisterEmployees();
        await this.loadLeaveEmployees();
      }
    },
    async entryEmployee(){
      if (this.selectedEmployee.valida === 1){
        return this.$message.warning("此员工为正常员工，不需要办理返聘！")
      }
      if (this.selectedEmployee.valida === 2){
        return this.$message.warning("此员工为注册员工，不需要办理返聘！")
      }
      const {data:res} = await this.$http.put(`/user/modifier/${this.userId}/user/${this.selectedEmployee.id}/valida/${1}`)
      if (res.code === 200){
        await this.loadEmployees();
        await this.loadRegisterEmployees();
        await this.loadLeaveEmployees();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadEmployees();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadEmployees();
    },

    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadRegisterEmployees();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadRegisterEmployees();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.loadLeaveEmployees();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.loadLeaveEmployees();
    },
    async loadRoles(){
      const {data:res} = await this.$http.get('roles');
      if (res.code === 200){
        this.roles = res.data;
      }
    },
    getRoleType(data){
      this.selectedEmployee.roleId = data;
    },
    showAllotRole(){
      this.allotRoleDialogVisible = true;
    },
    closeAllotRole(){
      this.allotRoleDialogVisible = false;
    },
    async updateUserRole(){
      const {data:res} = await this.$http.put(`/userRole/userOrgId/${this.selectedEmployee.userOrgId}/roleId/${this.selectedEmployee.roleId}`);
      await this.loadEmployees();
      this.closeAllotRole();
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.currentOrgId}`);
      if (res.code === 200){
        this.areaList = [res.data];
      }
    },
    async updateUserOrg(){
      if (this.newMultipleSelection.length === 0){
        return;
      }
      this.selectedEmployee.orgList = this.newMultipleSelection;
      const {data:res} = await this.$http.post(`/user/modifyOrg`, this.selectedEmployee);
      if (res.code === 200){
        this.$message.success("操作成功！")
        this.newMultipleSelection =[]
      }
      await this.loadEmployees();
      await this.loadRegisterEmployees();
      await this.loadLeaveEmployees();
    },
    areaHandleNodeClick(data){
      this.selectAreaId = data.id;
      this.loadShop();
    },
    async loadShop(){
      this.userRequest.orgId = this.selectAreaId;
      this.userRequest.pageNum = this.currentPage3;
      this.userRequest.pageSize = this.pageSize3;
      this.userRequest.shopName = this.shopQueryText;
      const {data:res} = await this.$http.post(`orgs/shop`, this.userRequest);
      this.shopList = res.data.list;
      this.pageTotal3 = res.data.total;
    },
    areaFilterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //关键字查询产品的方法
    queryShopMethod(){
      this.loadShop();
    },
    handleSizeChange3(val) {
      this.pageSize3 = val;
      console.log(`每页 ${val} 条`);
      this.loadShop();
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val;
      console.log(`当前页: ${val}`);
      this.loadShop();
    },
    async deleteUserOrg(){
      const {data:res} = await this.$http.delete(`/users/exsitOrg/userId/${this.selectedEmployee.id}/orgId/${this.selectedEmployee.orgId}`);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadEmployees();
    },
    addUserOrg(index, data){
      let result = false;
      this.multipleSelection.map((item) => {
        if (item.id === data.id){
          result = true;
        }
      })
      if (result === false){
        this.newMultipleSelection.push(data);
        this.multipleSelection.push(data);
      }
    }
  },
  watch: {
    areaFilterText(val) {
      this.$refs.serviceTree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.queryEmployee();
    //this.loadRegisterEmployees();
    //this.loadLeaveEmployees();
    this.loadRoles();
    this.loadAreaOrgs();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee.vue